import { render, staticRenderFns } from "./Separator.vue?vue&type=template&id=0280b163&scoped=true"
var script = {}
import style0 from "./Separator.vue?vue&type=style&index=0&id=0280b163&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0280b163",
  null
  
)

export default component.exports